require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-accessibility-avoid-colorblindness-issues-by-using-sufficient-contrast.json") })
        }
      }, "path---responsive-web-design-applied-accessibility-avoid-colorblindness-issues-by-using-sufficient-contrast");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-accessibility-avoid-colorblindness-issues-by-using-sufficient-contrast!./.cache/json/responsive-web-design-applied-accessibility-avoid-colorblindness-issues-by-using-sufficient-contrast.json
// module id = 2505
// module chunks = 231608221292675